export const getModuleInitialRoute = (currentPath) => {
  if (!currentPath) return null;

  const normalizedPath = currentPath.toLowerCase().replace(/\/$/, '');

  const routeMap = {
    '/v2/ucp': '/v2/ucp',
    '/v2/workspace': '/v2/workspace',
    '/v2/users': '/v2/users',
    '/v2/conversations': '/v2/conversations',
    '/v2/roles': '/v2/roles',
    '/v2/groups': '/v2/groups',
    '/v2/user-management': '/v2/user-management',
    '/v2/departments': '/v2/departments',
    '/v2/knowledge': '/v2/knowledge',
    '/v2/blast-campaigns': '/v2/blast-campaigns',
    '/v2/agentsview': '/v2/agentsView',
    '/v2/drives': '/v2/drives',
    '/v2/playground': '/v2/agentsView',
    '/v2/playground2': '/v2/agentsView',
    '/v2/questions': '/v2/questions',
    '/v2/personalization': '/v2/personalization',
    '/v2/template': '/v2/template',
    '/v2/agents-team': '/v2/agents-team',
    '/v2/home': '/v2/home',
    '/v2/workflows': '/v2/workflows',
    '/home': '/home',
    '/customers': '/customers',
    '/keys': '/keys',
    '/metrics': '/metrics',
    '/unified-profile': '/unified-profile',
  };

  if (routeMap[normalizedPath]) {
    return routeMap[normalizedPath];
  }

  for (const [routePrefix, initialRoute] of Object.entries(routeMap)) {
    if (normalizedPath.startsWith(routePrefix + '/') || normalizedPath === routePrefix) {
      return initialRoute;
    }
  }

  return null;
};

